import React, { useState } from "react";
import { ChevronDown } from "lucide-react";

function introductionLength(text) {
  if (text.length < 300 || typeof Intl.Segmenter !== "function") return text.length;
  const sentences = new Intl.Segmenter("en", { granularity: "sentence" }).segment(text);
  for (const { segment, index } of sentences) {
    const end = index + segment.length;
    if (end >= 100 && end <= text.length - 80) return end;
  }
  return text.length;
}

export const MobileParagraph = ({ id, text, className = "", label = "Read more" }) => {
  const [open, setOpen] = useState(false);
  const end = introductionLength(text);
  if (end === text.length) return <p className={className} data-testid={id}>{text}</p>;
  return <>
    <p className={className} data-testid={id}><span>{text.slice(0, end)}</span><span id={`${id}-continuation`} className="mobile-prose-continuation" data-expanded={open}>{text.slice(end)}</span></p>
    <button type="button" className="mobile-prose-toggle" data-testid={`${id}-toggle`} aria-expanded={open} aria-controls={`${id}-continuation`} onClick={() => setOpen(value => !value)}>{open ? "Read less" : label}<ChevronDown size={16} aria-hidden="true" /></button>
  </>;
};